export default __webpack_public_path__ + "static/media/2.166d8d57.svg";